import KmxHeartStroked from '@kmx/mui-icons/KmxHeartStroked';
import KmxListStroked from '@kmx/mui-icons/KmxListStroked';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useState } from 'react';
import CartDrawer from './CartDrawer/CartDrawer';
import FavoritesDrawer from './FavoritesDrawer/FavoritesDrawer';
import Logo from './Logo';
import SearchBar from './SearchBar/SearchBar';

const Header = () => {
  const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const theme = useTheme();
  const useMobileLayout = useMediaQuery(theme.breakpoints.down('sm'));

  const handleFavoritesClose = () => {
    setIsFavoritesOpen(false);
  };
  const handleFavoritesOpen = () => {
    setIsCartOpen(false);
    setIsFavoritesOpen(true);
  };

  const handleCartClose = () => {
    setIsCartOpen(false);
  };
  const handleCartOpen = () => {
    setIsFavoritesOpen(false);
    setIsCartOpen(true);
  };

  return (
    <>
      <Container
        maxWidth="xl"
        disableGutters
        sx={{
          px: { xs: 3, sm: 5, md: 8 },
        }}
      >
        <AppBar
          position="static"
          elevation={0}
          sx={{
            backgroundColor: 'white',
          }}
        >
          <Toolbar
            disableGutters
            sx={{
              gap: useMobileLayout ? 1 : 3,
              flexWrap: useMobileLayout ? 'wrap' : 'nowrap',
            }}
          >
            <Box sx={{ flexGrow: 1, a: { display: 'inline-block' }, order: 1 }}>
              <a href="/">
                <Logo />
              </a>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                order: useMobileLayout ? 3 : 2,
                flexBasis: useMobileLayout ? '100%' : 'auto',
              }}
            >
              <SearchBar />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'flex-end',
                order: useMobileLayout ? 2 : 3,
              }}
            >
              <IconButton onClick={handleFavoritesOpen} sx={{ mr: 0.25 }}>
                <KmxHeartStroked />
              </IconButton>
              <IconButton
                onClick={handleCartOpen}
                variant="outlined"
                size="small"
                sx={{ borderRadius: 9999, gap: 1, pr: 1.5 }}
              >
                <Avatar sx={{ width: 32, height: 32 }} />
                <KmxListStroked />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <FavoritesDrawer
          open={isFavoritesOpen}
          onClose={handleFavoritesClose}
        />
        <CartDrawer open={isCartOpen} onClose={handleCartClose} />
      </Container>
      <Divider />
    </>
  );
};

export default Header;
